<template>
  <li v-if="routerName" class="tab-item" :class="[variant, {active:isActive()}]">
    <router-link :to="{name: routerName}" class="atag">
      <slot></slot>
    </router-link>
  </li>
  <li v-else-if="tabName" class="tab-item" :class="[variant, {active:isActive()}]" @click.prevent="activate(tabName)">
    <a class="atag">
      <slot></slot>
    </a>
  </li>
  <li v-else class="tab-item" :class="[variant, {active:isActive()}]">
    <slot></slot>
  </li>
</template>

<script>
export default {
  name: 'tab-item',
  props: ['variant', 'routerName', 'tabName', 'active'],
  methods: {
    activate: function (val) {
      this.$emit('onclick', val)
    },
    isActive: function () {
      return this.tabName && (this.$parent.$parent.active === this.tabName)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/stylesheets/styles";
.tab-item {
  text-align: center;
  display: inline-block;
  list-style-type: none;
  border: 1px solid $secondary;
  border-bottom: none;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  cursor: pointer;
  >.atag {
    height: 100%;
    display: block;
    padding: 0;
    text-align: center;
    color: $black;
    line-height: 100%;
    font-size: 16px;
    &:hover {
      text-decoration: none;
    }
    @include mq-down(md) {
      font-size: 14px;
    }
    @media screen and (max-width: 321px) {
      font-size: 12px;
    }
  }
  .tab-bordered & {
    height: 60px;
    &.active {
      background-color: white;
      border-top: 5px solid $orange;
      >.atag {
        padding: 17px 0;
      }
    }
    >.atag {
      padding: 22px 0;
    }
    &.-reflect {
      >.atag {
        color: $white;
      }
      &.active {
        >.atag {
          color: $black;
        }
      }
    }
  }
  .tab-filled & {
    height: 52px;
    &.active {
      >.atag {
        color: $white;
      }
    }
    >.atag {
      padding: 18px 0;
    }
  }
  .tab-filled.-tab-orange & {
    &.active {
      background-color: $orange;
      border: 1px solid $orange;
    }
  }
  .tab-filled.-tab-green & {
    &.active {
      background-color: $green;
      border: 1px solid $green;
    }
  }
  @include mq-up(md) {
    .tab-header.-sm & {
      @for $i from 1 through 100 {
        &:nth-last-child(#{$i}) {
          &,
          & ~ .tab-item {
            width: percentage(.95/$i);
          }
        }
      }
    }
    .tab-header.-md & {
      @for $i from 1 through 100 {
        &:nth-last-child(#{$i}) {
          &,
          & ~ .tab-item {
            width: percentage(.98/$i);
          }
        }
      }
    }
    .tab-header.-lg & {
      @for $i from 1 through 100 {
        &:nth-last-child(#{$i}) {
          &,
          & ~ .tab-item {
            width: percentage(.99/$i);
          }
        }
      }
    }
  }
  @include mq-down(md) {
    .tab-bordered & {
      @for $i from 1 through 100 {
        &:nth-last-child(#{$i}) {
          &,
          & ~ .tab-item {
            width: percentage(.95/$i);
          }
        }
      }
    }
    .tab-filled & {
      width: 50%;
      border-top: none;
      border-bottom: 1px solid $secondary;
      border-radius: 0;
      &.active {
        border-top: none !important;
      }
      &:nth-of-type(even) {
        border-left: none;
        // margin-left: -.3em;
      }
      &:nth-of-type(1) {
        border-top: 1px solid $secondary;
        border-top-left-radius: 10px;
        &:nth-last-of-type(1) {
          border-top-right-radius: 10px;
          border-bottom-right-radius: 10px;
        }
      }
      &:nth-of-type(2) {
        border-top: 1px solid $secondary;
        border-top-right-radius: 10px;
      }
      &:nth-last-of-type(2) {
        border-bottom: 1px solid $secondary;
        &:nth-of-type(odd) {
          border-bottom-left-radius: 10px;
        }
        &:nth-of-type(even) {
        }
      }
      &:nth-last-of-type(1) {
        &:nth-of-type(odd) {
          border-bottom-left-radius: 10px;
        }
        &:nth-of-type(even) {
          border-bottom-right-radius: 10px;
        }
      }
    }
    .tab-filled.-tab-orange & {
      &:nth-of-type(1),
      &:nth-of-type(2) {
        &.active {
          border-top: 1px solid $orange !important;
        }
      }
    }
    .tab-filled.-tab-green & {
      &:nth-of-type(1),
      &:nth-of-type(2) {
        &.active {
          border-top: 1px solid $green !important;
        }
      }
    }
    .tab-header.-arrow & {
      background-size: 8px auto;
      background-position: right 12px center;
      background-repeat: no-repeat;
      .-tab-orange & {
        background-image: url('../../assets/images/icons/arrow-right-orange.svg');
      }
      .-tab-green & {
        background-image: url('../../assets/images/icons/arrow-right-green.svg');
      }
    }
  }
  .tab-sticky & {
    border-radius: 0;
    width: 49.5%;
    height: 50px;
    border: none;
    font-size: 0;
    >.atag {
      font-size: 16px;
      color: $white;
      padding: 15px 0;
    }
    &.-orange {
      background-color: $orange;
      border-top: solid 3px $orange;
    }
    &.-green {
      background-color: $green;
      border-top: solid 3px $green;
    }
  }
  .show & {
    &.active {
      border-bottom: none;
      >.atag {
        color: $black;
      }
      &.-orange {
        background-color: $success;
      }
      &.-green {
        background-color: $twilight;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/tabs/TabItem.vue